export default __webpack_public_path__ + "static/media/question-mark.9cb3cc91.svg";